<template>
    <div :id="!isExpanded ? 'main' : 'expanded'">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
         aqui2
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ title }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    tag="button"
                    @click="fechar()"
                >
                    {{ $t("fechar") }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save()"
                    :disabled="isLoading || !((inputText != null) || selected)"
                >
                    {{ $t("salvar") }}
                    <button-loader :isSaving="isLoading" />
                </button>
            </div>
        </div>
        <section>
            <div class="modal-card">
                <section class="modal-card-body modal-es">
                    <div class="columns">
                        <div class="column">
                            <vss-select
                                title="vendedores"
                                label="nome"
                                v-model="vendedoresSelected"
                                :options="vendedoresOptions"
                                :loading="vendedoresLoading"
                                @search="SearchVendedores"
                                @input="clearSelect($event, 'vendedores')"
                                :closeOnSelect="false"
                                clearable
                                noClearfix 
                                multiple 
                                learable 
                                searchable
                            >
                                <template #multiple-selected="{ selected }">
                                    ({{ selected && selected.length > 0 ? selected.length : $t("todos") }})
                                </template>
                            </vss-select>
                        </div>
                    </div>
                    <div class="columns">
                        <div v-if="!isUpdate" class="column">
                            <vss-select
                                title="parametrizacao"
                                ref="parametrizacoesInput"
                                class="nova-parametrizacao-select"
                                :options="configs"
                                v-model="configSelected"
                                :clearable="false"
                                @input="onCleanConfigs"
                                @search="searchConfigs"
                                searchable
                                noClearfix
                            >
                            </vss-select>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <div v-if="isUpdate" class="conteudo-parametrizacao-valor">
                                <vss-select
                                    title="valor"
                                    ref="periodoDescricaoInput"
                                    label="label"
                                    :options="options"
                                    :disabled="isUpdate"
                                    :clearable="false"
                                    v-model="selected"
                                />
                            </div>
                            <div v-else class="conteudo-parametrizacao-valor">
                                <label v-text="$t('valor')"/>
                                <v-select
                                    v-if="options.length != 0"
                                    ref="valorSelect"
                                    label="label"
                                    :options="options"
                                    :clearable="false"
                                    v-model="selected"
                                />
                                <input
                                    :value="typeInput === 'number' ? inputText : ''"
                                    v-else
                                    v-model="inputText"
                                    :type="typeInput"
                                    required
                                />
                            </div>
                        </div>
                    </div>
                    <div class="columns content">
                        <div class="column">
                            <v-textarea
                                ref="obsTextArea"
                                class="obs-ta"
                                v-model="descricao"
                                title="descricao"
                                :maxlength="isUpdate ? descricao.length : 2000"
                                :readonly="true"
                                :disabled="true"
                            />
                        </div>
                    </div>
                </section>
            </div>
        </section>
    </div>
</template>

<!-- @86942 e 86973 - adaptado para que o mesmo modal fosse utilizado para inserir e editar -->
<script>
import ParametrizacaoUsuarioService from "@/services/ParametrizacaoUsuarioService";
import ParametrizacaoService from "@/services/ParametrizacaoService";
import Message from "@/models/Message";
import ColaboradorService from "@/services/ColaboradorService";

export default {
    data() {
        return {
            isLoading: false,
            service: new ParametrizacaoUsuarioService(this.$http, this.$router),
            serviceConfig: new ParametrizacaoService(this.$http, this.$router),
            colaboradorService: new ColaboradorService(this.$http, this.$router),
            selected: null,
            options: [],
            msgs: [],
            configs: [],
            vendedoresOptions: [],
            vendedoresLoading: false,
            vendedoresSelected: [],
            usrsConfigs: [],
            configSelected: null,
            descricao: "",
            title: "",
            isExpanded: false,
            isUpdate: false,
            inputText: "",
            typeInput: "text",
        };
    },
    props: {
        parametrizacaoUsuario: {},
    },
    created() {
        this.isUpdate = this.parametrizacaoUsuario != null;
        this.title = this.$t("nova-parametrizacao");
        if(this.isUpdate) {
            this.title = this.parametrizacaoUsuario["label-tabela-usuario"];
            this.descricao = this.parametrizacaoUsuario['descricao'];
            this.selected = this.parametrizacaoUsuario['valor'];
            this.configSelected = this.parametrizacaoUsuario;
            this.parametrizacaoUsuario.label = this.parametrizacaoUsuario["label-tabela-usuario"];
            this.renderInput();
        }else {
            this.loadConfigs();
        }
        this.loadVendedores();
    },
    methods: {
        fechar() {
            this.$emit("fecharModal", "especifica");
        },
        renderInput() {
            if (
                this.parametrizacaoUsuario.tipo &&
                this.parametrizacaoUsuario.tipo === "select"
            ) {
                let json = JSON.parse(this.parametrizacaoUsuario.tipo);
                this.options = json.options;
                this.selected = this.options.find(
                    (e) => e.name === this.parametrizacaoUsuario.valor
                );
            }
        },
        newRenderInput(value) {
            if (value.tipo) {
                let json = JSON.parse(value.tipo);
                if (json.type === "select") {
                    this.options = json.options.map((e) => ({
                        id: e.value,
                        label: e.name,
                    }));
                    this.selected = this.options[0];
                } else {
                    this.typeInput = json.type;
                    this.inputText = json.type === "number" ? 0 : "";
                }
            }
        },
        updateExpanded() {
            this.isExpanded = !this.isExpandend;
        },
        carregarVendedoresSelected() {
            const thisVm = this;
            this.vendedoresSelected = this.vendedoresOptions.filter(({idusuario}) => 
                thisVm.usrsConfigs.some(({idusuario: idusuarioConfigs}) => idusuarioConfigs === idusuario))
        },
        loadVendedores() {
            this.vendedoresLoading = true;
            this.colaboradorService
            .findListAssociated("", 5000000)
            .then((r) => {
                this.vendedoresOptions = r.content;
            })
            .catch((e) => {
                console.error("Erro ao carregar vendedores.", e);
            })
            .finally((_) => {
                this.vendedoresLoading = false;
                if (this.isUpdate) this.getUsersConfigsByNameAndValue();
            });
        },
        SearchVendedores(q) {
            this.vendedoresLoading = true;
            this.colaboradorService
            .findListAssociated(q, 5000000)
            .then((r) => {
                this.vendedoresOptions = r.content;
            })
            .catch((e) => {
                console.error("Erro ao carregar vendedores.", e);
            })
            .finally((_) => {
                this.vendedoresLoading = false;
            });
        },
        save() {
            if (this.options.length == 0 && this.isNull(this.inputText)) {
                this.msgs.push(new Message("warning", "msg-campo-valor", true));
                return;
            } else if (this.options.length > 0 && this.isNull(this.selected.id)) {
                this.msgs.push(new Message("warning", "msg-campo-valor", true));
                return;
            }
            this.isLoading = true;
            let listagemConfig = [];
            this.vendedoresSelected =
                this.vendedoresSelected.length > 0
                    ? this.vendedoresSelected
                    : this.vendedoresOptions;
            this.vendedoresSelected.forEach((v) => {
                let obj = { ...this.configSelected };
                obj.idusuario = v.idusuario;
                obj.usuarios = 0;
                if (this.selected && this.selected.id) {
                    obj.valor = this.selected.id;
                } else {
                    obj.valor = this.inputText;
                }
                listagemConfig.push(obj);
            });
            this.$axios
                .post('config/usuario', listagemConfig)
                .then((value) => {
                    if (value.data.content == null) {
                        this.msgs.push(
                            new Message(
                                "error",
                                "erro-edit-parametrizacao",
                                true
                            )
                        );
                    } else {
                        this.msgs.push(
                            new Message(
                                "success",
                                "sucesso-edit-parametrizacao",
                                true
                            )
                        );
                        setTimeout(() => {
                            this.fechar();
                        }, 1000);
                    }
                })
                .catch((e) => {
                    if (e.status == 409) {
                        let msg = this.$t("msg-conflito-configusuario", { n: e.data.message });
                        this.msgs.push(new Message("error", msg, true))
                        return
                    }

                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        getUsersConfigsByNameAndValue() {
            /* Esse metodo trás todos os usuarios que estão utilizando essa config com esse valor */
            this.service
                .getAllUsersConfigsByValueAndName(
                    this.parametrizacaoUsuario.nome,
                    this.parametrizacaoUsuario.valorOriginal
                )
                .then((r) => {
                    if (r.content) this.usrsConfigs = r.content;
                })
                .catch((e) => {
                    console.error("Erro ao carregar configs.", e);
                })
                .finally((_) => {
                    this.carregarVendedoresSelected();
                });
        },
        clearSelect(value, select) {
            if (value.length == 0) {
                if (select == "vendedores") this.vendedoresSelected = [];
            }
        },
        searchConfigs(search) {
            this.configs = [];
            this.loadConfigs(search)
        },
        loadConfigs(search) {
            this.serviceConfig
                .findAllCombo(search)
                .then((value) => {
                    if (value.status === 200) {
                        if (value.content) {
                            value.content.map((e) => {
                                this.configs.push({
                                    id: e.idconfig,
                                    label: e.label,
                                    nome: e.nome,
                                    descricao: e.descricao,
                                    tipo: e.tipo,
                                    situacao: e.situacao,
                                    idcategoriaconfig: e.idcategoriaconfig,
                                });
                            });

                            this.configSelected = this.configs[0];

                            this.newRenderInput(this.configSelected);
                            this.descricao = this.configSelected.descricao;
                        }
                    } else {
                        this.configs = [];
                        this.configSelected = {};
                        this.msgs.push(
                            new Message("error", "msg-erro-load", true)
                        );
                    }
                })
                .catch((e) => {
                    console.error("Erro ao carregar as parametrizacoes.", e);
                })
                .finally((_) => {
                    this.vendedoresLoading = false;
                });
        },
        onCleanConfigs(val) {
            this.options = [];
            this.selected = null;
            if (val) {
                this.newRenderInput(val);
                this.descricao = val.descricao;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    #main {
        padding: 20px 20px !important;
        height: 100%;

        span {
            font-size: 13px;
        }

        .conteudo-parametrizacao {
            display: flex;
            align-items: center;
            padding: 20px 0px;
            flex-direction: column;

            .conteudo-parametrizacao-descricao {
                width: 70%;
            }

            .conteudo-parametrizacao-valor {
                display: flex;
                align-items: center;
                flex-direction: row;
                width: 80%;
                margin-top: 15px;

                span {
                    margin-right: 10px;
                }

                div {
                    width: 100%;
                }
            }
        }
    }

    #expanded {
        padding: 20px 20px !important;
        height: 800px;

        span {
            font-size: 13px;
        }

        .conteudo-parametrizacao {
            display: flex;
            align-items: center;
            padding: 20px 0px;
            flex-direction: column;

            .conteudo-parametrizacao-descricao {
                width: 70%;
            }

            .conteudo-parametrizacao-valor {
                display: flex;
                align-items: center;
                flex-direction: row;
                width: 80%;
                margin-top: 15px;

                span {
                    margin-right: 10px;
                }

                div {
                    width: 100%;
                }
            }
        }
    }
</style>